import { render } from "./Customizable.vue?vue&type=template&id=263d6fb1"
import script from "./Customizable.vue?vue&type=script&lang=js"
export * from "./Customizable.vue?vue&type=script&lang=js"

import "./Customizable.vue?vue&type=style&index=0&id=263d6fb1&lang=css"
script.render = render

export default script